import type { StackBodySnapshot } from './score';

export const WORLD_UNITS_PER_METER = 100;

export interface StackMeasurement {
  stackLengthWorld: number;
  meters: number;
}

function finiteNonNegative(value: number): number {
  return Number.isFinite(value) ? Math.max(0, value) : 0;
}

export function measureStack(
  bodies: readonly StackBodySnapshot[],
  supportAnchorWorldY: number,
): StackMeasurement {
  const anchor = Number.isFinite(supportAnchorWorldY) ? supportAnchorWorldY : 0;
  let bottom = anchor;

  for (const body of bodies) {
    if (body.placed && body.supportConnected && Number.isFinite(body.bottomY)) {
      bottom = Math.max(bottom, body.bottomY);
    }
  }

  const stackLengthWorld = finiteNonNegative(bottom - anchor);
  return {
    stackLengthWorld,
    meters: stackLengthWorld / WORLD_UNITS_PER_METER,
  };
}

export function formatMeters(meters: number): string {
  const normalized = finiteNonNegative(meters);
  const rounded = normalized.toFixed(1);
  return `${rounded === '0.0' ? '' : '-'}${rounded} m`;
}

export function updateRunMeters(previous: number, measured: number): number {
  return Math.max(finiteNonNegative(previous), finiteNonNegative(measured));
}
